export const ORDER_BY_ENUM = {
  ASC: 'ASC',
  DESC: 'DESC',
};
